const MIN = 60_000;
/** La sala abre 5 minutos antes y cierra 15 después del fin (igual que psi-video) */
const OPEN_BEFORE_MIN = 5;
const CLOSE_AFTER_MIN = 15;

export type SessionPhase =
  { kind: "upcoming"; ms: number } | { kind: "live" } | { kind: "over" };

/** En qué momento está una sesión: por empezar (con los ms que faltan para que abra la sala), en curso o terminada. */
export function sessionPhase(
  start: string,
  durationMin: number,
  now: number,
): SessionPhase {
  const s = Date.parse(start);
  if (now < s - OPEN_BEFORE_MIN * MIN)
    return { kind: "upcoming", ms: s - OPEN_BEFORE_MIN * MIN - now };
  if (now <= s + (durationMin + CLOSE_AFTER_MIN) * MIN) return { kind: "live" };
  return { kind: "over" };
}

/** "2 d 3 h", "3 h 5 min", "12 min", "40 s" */
export function formatCountdown(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const d = Math.floor(total / 86400);
  const h = Math.floor((total % 86400) / 3600);
  const m = Math.floor((total % 3600) / 60);
  if (d > 0) return `${d} d ${h} h`;
  if (h > 0) return `${h} h ${m} min`;
  if (m > 0) return `${m} min`;
  return `${total} s`;
}

/** "mar 20 oct, 15:00" en la zona horaria del navegador */
export function formatSessionDate(iso: string): string {
  return new Intl.DateTimeFormat("es", {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(iso));
}

/** "12:05" o "1:02:05": cronómetro desde un tiempo en milisegundos */
export function formatClock(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}
